import React, { useState } from "react";
import "./DoctorsGridPageCss/PatientStories.css";

const StoryCard = ({ story }) => {
    const [expanded, setExpanded] = useState(false);

    const toggleExpanded = () => setExpanded((prev) => !prev);

    const shouldTruncate = story.patientStory.length > 150;

    const visibleText = shouldTruncate && !expanded
        ? story.patientStory.slice(0, 150)
        : story.patientStory;

    return (
        <div className="story-card">
            <h4 className="patient-name">{story.patientName}</h4>
            <p className="story-text">
                {visibleText}
                {shouldTruncate && (
                    <>
                        {!expanded && "... "}
                        <span className="read-more-inline" onClick={toggleExpanded}>
                            {expanded ? " Show Less" : " Read More"}
                        </span>
                    </>
                )}
            </p>
        </div>
    );
};


const PatientStories = ({ stories }) => {
    if (!stories || stories.length === 0) {
        return <p style={{ color: "#777" }}>No patient stories available.</p>;
    }

    return (
        <div className="storiesSection">
            <h3 style={{ marginBottom: "12px", color: "#333" }}>Patient Stories</h3>
            <div className="story-list">
                {stories.map((story, index) => (
                    <StoryCard key={index} story={story} />
                ))}
            </div>
        </div>
    );
};

export default PatientStories;
